import { type MachineLogicServices } from '@vse/MachineLogicServices';
import { navigationService } from './NavigationService';

export const machineLogicServices: MachineLogicServices = {
  NavigationService: navigationService,
};
